// extracted by mini-css-extract-plugin
export default {"planning":"Planning_planning__YuO6d","title-pic":"Planning_title-pic__i1uMH","car":"Planning_car__TW77r"};